
import React from "react";
import { Button } from "@/components/ui/button";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue
} from "@/components/ui/select";
import { Textarea } from "@/components/ui/textarea";
import { LensFormValues } from "@/types/inventory";
import { UseFormReturn } from "react-hook-form";
import { useIsMobile } from "@/hooks/use-mobile";
import { CalendarDays } from "lucide-react";
import { LensTabsForm } from "./LensTabsForm";

interface AddLensFormProps {
  form: UseFormReturn<LensFormValues>;
  onSubmit: (values: LensFormValues) => Promise<void>;
  isEditing?: boolean;
}

// This is now a wrapper component that uses the new LensTabsForm
export function AddLensForm({ form, onSubmit, isEditing = false }: AddLensFormProps) {
  return <LensTabsForm form={form} onSubmit={onSubmit} isEditing={isEditing} />;
}
